<script setup>
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
import { isLoading, isLiveDisplay } from './router';

import PageLoader from './components/PageLoader.vue';

</script>

<template>
  <Transition name="fade">
    <PageLoader v-if="isLoading && !isLiveDisplay" />
  </Transition>
  <RouterView />
  <Toast />
</template>

<style scoped>
   /* Initial state for entering */
   .fade-enter-from, .fade-leave-to {
      opacity: 0;
    }

    /* Target state for entering */
    .fade-enter-to, .fade-leave-from {
      opacity: 1;
    }

    /* Transition */
    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.5s ease-in-out;
    }
</style>
